import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Card, Grid, Typography } from '@mui/material'

import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'

import BoxTitle from 'components/atoms/BoxTitle'
import SwiperSliderComponent from 'components/organisms/swiper/SwiperSliderComponent'

import { ELEMENT_RADIUS_MID } from 'utils/customizedTheme'
import { useNavigate } from 'react-router-dom'
import { Assignment } from '@mui/icons-material'

const Courses: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data } = useGET_groupCoursesQuery({
    page: 1,
  })
  const list = data?.results.map((item) => {
    return item.subject
  })
  const result =
    list &&
    list.filter((value, index, self) => {
      return self.findIndex((v) => v.id === value.id) === index
    })

  const slides =
    result &&
    result.map((item) => {
      return (
        <Card
          sx={{
            cursor: 'pointer',
            width: '10rem',
            height: 'auto',
            textAlign: 'center',
            backgroundColor: `${item.color_hex_code}`,
            padding: '1rem',
            borderRadius: `${ ELEMENT_RADIUS_MID } !important`,
          }}
        >
          <img style={{ height: '120px' }} src={`${item.icon}`} alt='icon' onClick={ () => navigate('/student-assignments') }/>
          <Typography sx={{ textAlign: 'center' }}> {item.title}</Typography>
        </Card>
      )
    })

  return (
      <Grid container spacing={2}>
        <Grid item xs={12} xl={6}>
          <BoxTitle title={t('common.courses')}  icon={<Assignment />}  />
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex' }}>
          <SwiperSliderComponent
            components={slides}
            slidesPerView={4}
            paginationBullets={'off'}
            navigationArrows={'on'}
            padding={true}
            color={'dark'}
          />
        </Grid>
      </Grid>
  )
}

export default Courses
